import { useEffect, Fragment, useState, useMemo } from 'react';
import { UseFormRegister, UseFormWatch, UseFormSetValue } from 'react-hook-form';
import { scrollBarStyle } from 'constants/theme';
import styled from 'styled-components';
import IndeterminateCheckbox from 'components/Table/util/IndeterminateCheckbox';
import { ReactComponent as IcDateFill } from 'constants/icon/ic_date_fill_gray.svg';
import { useIsDifferenceStore } from 'pages/Message/common/MessagePromptStore';
import useToastStore from 'components/Toast/ToastStore';
import { ISingleHistoryMessage } from '../../HistoryStore';
import { IChangeMessageLocalState } from './MainMessageComponent';
import DatePickerPopup from 'components/Popup/DatePicker';
import dayjs from 'dayjs';
import { ReactComponent as IconCancle } from 'constants/icon/icon_cancle.svg';
import { Button } from 'components/Button';
import { Text } from 'components/Typography';
import { AlertModal } from 'components/Modal/AlertModal';
import Modal from 'components/Modal';
import AddModal from '../AddModal';
import { ReactComponent as IconClose } from 'constants/icon/ic_close_16.svg';
/////
import { OptionalFilterList } from 'pages/Message/Manual/ManualTable';
import ManualTable from 'pages/Message/Manual/ManualTable';
import { useCheckedCustomerInfos } from 'pages/Message/Manual/ManualStore';
export type TRequestFilter = {
  orderStatus: string;
  startDate: string;
  endDate: string;
  searchItem?: string;
  keyword?: string;
};
//////////

type Props = {
  isOnChange: boolean;
  watch: UseFormWatch<Partial<IChangeMessageLocalState>>;
  setValue: UseFormSetValue<Partial<IChangeMessageLocalState>>;
};
const ChangeMessageComponent = ({ isOnChange, watch, setValue }: Props) => {
  const { setIsDifference } = useIsDifferenceStore();
  const { addToast } = useToastStore();
  const { checkedCustomerInfos, setCheckedCustomerInfos } = useCheckedCustomerInfos();
  const [isOpenCalander, setIsOpenCalander] = useState(false);

  const [isToastShown, setIsToastShown] = useState(false);

  const encodedLength = useMemo(() => {
    const encoder = new TextEncoder();
    const encoded = encoder.encode(watch('contents'));
    return encoded.length;
  }, [watch('contents')]);

  const isOver90Length = useMemo(() => {
    return encodedLength > 90;
  }, [encodedLength]);

  // 수신인 추가 모달창 넓이 80% 처리를 위한 상태값
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  // 수신인 추가 모달창
  const [isOpenAddRecipentModal, setIsOpenAddRecipentModal] = useState(false);

  /////////////
  const [requestFilter, setRequestFilter] = useState<TRequestFilter>({
    orderStatus: 'all',
    startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
    endDate: dayjs().format('YYYY-MM-DD'),
    // searchItem: OptionalFilterList[0].value,
    // keyword: '',
  });
  ////////////

  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onClickCancelModal = () => {
    // 수신인 추가 모달창 닫기 + 체크된 수신인 초기화
    setIsOpenAddRecipentModal(false);
    setCheckedCustomerInfos([]);
  };
  const onClickaddRecipentModal = () => {
    // 1. 기존 수신인 정보 + 중복된 수신인 정보 제거 및 추가
    const currentRecipentInfos = watch('recipent_infos') ?? []; // 기존 수신인정보
    const currentCheckedCustomerInfos = checkedCustomerInfos; // 체크된 수신인정보
    // 중복된 수신인 정보 제거 및 추가
    const filteredRecipentInfos = currentCheckedCustomerInfos.filter(currentCheckedCustomerInfo => {
      return !currentRecipentInfos.some(
        currentRecipentInfo => currentRecipentInfo.customer_phone === currentCheckedCustomerInfo.customer_phone
      );
    });
    const newRecipentInfos = [...currentRecipentInfos, ...filteredRecipentInfos];
    setValue('recipent_infos', newRecipentInfos);
    // 2. 체크된 수신인 초기화
    setCheckedCustomerInfos([]);
    // 3. 모달 창 닫기
    setIsOpenAddRecipentModal(false);
  };

  return (
    <Fragment>
      <FirstDiv>
        <FirstDivTitle>
          <div>1.메시지 제목</div>
          <SecondDivTitleDescriptionDiv>90byte 이하의 단문메시지는 제목이 미발송됩니다.</SecondDivTitleDescriptionDiv>
        </FirstDivTitle>
        <FirstDivTitleInput
          value={watch('title')}
          onChange={e => {
            if (watch('title') === e.target.value) {
              setIsDifference(true);
            }
            return setValue('title', e.target.value);
          }}
          placeholder="제목을 입력해주세요."
          disabled={!isOnChange}
        />
      </FirstDiv>
      <SecondDiv>
        <SecondDivTitle>
          <div>2.메시지 내용</div>
          <SecondDivTitleDescriptionDiv>
            <div>90byte 초과시 장문메시지로 자동 변환합니다.</div>
            <div style={{ display: 'flex' }}>
              {isOver90Length && <LMSLabel>LMS</LMSLabel>}(
              {isOver90Length && <SecondDivOver90Text>{encodedLength}</SecondDivOver90Text>}
              {!isOver90Length && encodedLength}
              /90byte)
            </div>
          </SecondDivTitleDescriptionDiv>
        </SecondDivTitle>
        <SecondDivCententContainer isTextArea={isOnChange}>
          <SecondDivCententTextArea
            placeholder="메시지 내용을 입력해주세요."
            value={watch('contents')}
            onChange={e => {
              setIsDifference(true);
              const encoder = new TextEncoder();
              const targetEncodedLength = encoder.encode(e.target.value).length;
              if (targetEncodedLength > 90 && !isToastShown) {
                addToast('장문메시지(LMS)로 전환됐습니다.', 3000);
                setIsToastShown(true);
              }
              if (targetEncodedLength <= 90) {
                setIsToastShown(false);
              }
              return setValue('contents', e.target.value);
            }}
            disabled={!isOnChange}
          />
        </SecondDivCententContainer>
      </SecondDiv>
      <ThirdDiv>
        <ThirdDivTitleDiv>
          <ThirdDivTitleText>3.예약 날짜/시간 지정</ThirdDivTitleText>
          <ThirdDivTitleDescriptionText>메시지를 보낼 시간을 예약하거나 직접 발송합니다.</ThirdDivTitleDescriptionText>
        </ThirdDivTitleDiv>
        <ThirdDivDateContainer>
          <ThirdDivDateInputContainer isDisabled={!isOnChange}>
            <CalanderIconContainer
              isActive={isOpenCalander}
              hasError={false}
              onClick={() => {
                if (!isOnChange) {
                  return;
                }
                return setIsOpenCalander(true);
              }}
            >
              <IcDateFill />
            </CalanderIconContainer>
            <input
              readOnly
              onClick={() => {
                setIsDifference(true);
                return setIsOpenCalander(true);
              }}
              value={watch('date')}
              placeholder="날짜를 선택해 주세요."
              disabled={!isOnChange}
              style={{ color: isOnChange ? '#25282f' : '#6e727c' }}
            />

            {isOpenCalander && (
              <div style={{ position: 'relative', top: -15, right: 390 }}>
                <DatePickerPopup
                  setIsOpen={setIsOpenCalander}
                  setValue={setValue}
                  initDate={watch('date') ?? ''}
                  name="date"
                  format="YYYY.MM.DD"
                  banPast={true}
                />
              </div>
            )}
          </ThirdDivDateInputContainer>
          <TimeContaniner isDisabled={!isOnChange}>
            <TimeInput
              type="number"
              value={watch('hour')}
              onChange={e => {
                const value = parseInt(e.target.value);
                if (value < 0) return setValue('hour', '00');
                if (value > 23) return setValue('hour', '23');
                else setValue('hour', value.toString().length === 1 ? `0${value}` : value.toString());
              }}
              disabled={!isOnChange}
            />
            <TimeText>시</TimeText>
          </TimeContaniner>
          :
          <TimeContaniner isDisabled={!isOnChange}>
            <TimeInput
              type="number"
              value={watch('minute')}
              onChange={e => {
                const value = parseInt(e.target.value);
                if (value < 0) return setValue('minute', '00');
                if (value > 59) return setValue('minute', '59');
                else return setValue('minute', value.toString().length === 1 ? `0${value}` : value.toString());
              }}
              disabled={!isOnChange}
            />
            <TimeText>분</TimeText>
          </TimeContaniner>
        </ThirdDivDateContainer>
      </ThirdDiv>
      <FirthDiv>
        <FirthDivTitleWrapper>
          <FirthDivTitle>4.수신인</FirthDivTitle>
          <FirthDivDescription>메시지를 보낼 수신인을 왼쪽 표에서 선택(체크)할 수 있습니다.</FirthDivDescription>
        </FirthDivTitleWrapper>
        <FirthCustomerInfoContainer>
          {(watch('recipent_infos') ?? []).map((customerInfo, index) => (
            <FirthCustomerInfoItem key={`${customerInfo.customer_phone}_${index}`}>
              {customerInfo.customer_name}/{customerInfo.customer_phone}
              {isOnChange && (
                <IconCancle
                  onClick={() => {
                    const newRecipentInfos = [...(watch('recipent_infos') ?? [])];
                    newRecipentInfos.splice(index, 1);
                    setValue('recipent_infos', newRecipentInfos);
                  }}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </FirthCustomerInfoItem>
          ))}
        </FirthCustomerInfoContainer>
        {isOnChange && (
          <FirthCustomerInfoButton
            variant="primary"
            h={40}
            sx={{ width: '100%', marginTop: '40px' }}
            onClick={() => {
              setIsOpenAddRecipentModal(true);
            }}
          >
            <Text styleName="body1" color="#2E66F6">
              수신인 추가/삭제
            </Text>
          </FirthCustomerInfoButton>
        )}
      </FirthDiv>
      <AddModal isModalOpen={isOpenAddRecipentModal} width={viewportWidth * 0.8} nomt={false}>
        <ManualTable
          requestFilter={requestFilter}
          setRequestFilter={setRequestFilter}
          sx={{ padding: 24 }}
          closeButton={<IconClose width={20} height={20} style={{ cursor: 'pointer' }} onClick={onClickCancelModal} />}
        />
        <ModalButtonContainer>
          <div style={{ width: '60%' }}></div>
          <ModalButtonCancel type="button" variant="secondary" h={40} onClick={onClickCancelModal}>
            취소
          </ModalButtonCancel>
          <ModalButtonAdd type="button" variant="secondary" h={40} onClick={onClickaddRecipentModal}>
            추가하기({checkedCustomerInfos.length})
          </ModalButtonAdd>
        </ModalButtonContainer>
      </AddModal>
    </Fragment>
  );
};

export default ChangeMessageComponent;

const FirstDiv = styled.div`
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;
const FirstDivTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  color: var(--RG02, #25282f);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body16B */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: -0.32px;
`;
const FirstDivTitleInput = styled.input`
  display: flex;
  height: 40px;
  padding: 6px 8px 6px 12px;
  align-items: center;
  align-self: stretch;

  border-radius: 6px;
  border: 1px solid var(--RG06, #d8ddea);
  background: var(--RG00, #fff);

  /* subheadline2 */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;

  :disabled {
    color: #6e727c;
  }
`;

const SecondDiv = styled.div`
  display: flex;
  height: 432px;
  padding: 0px 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;
const SecondDivTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  color: var(--RG02, #25282f);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body16B */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: -0.32px;
`;
const SecondDivTitleDescriptionDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;

  color: var(--GrayScale-gray800, #565b69);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body14M */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;
`;
const SecondDivCententContainer = styled.div<{ isTextArea: boolean }>`
  display: flex;
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;

  border-radius: 8px;
  border: 1px solid var(--RG06, #d8ddea);
  background: ${({ isTextArea, theme }) => (isTextArea ? theme.colors.RG00 : '#f9f9f9')};
`;
const SecondDivCententTextArea = styled.textarea`
  flex: 1;
  padding: 8px 10px;
  height: 100%; /* 부모 컨테이너의 높이를 따르게 설정 */
  resize: none; /* 필요에 따라 크기 조정 기능을 비활성화 */
  //textarea 스크롤바 적용
  overflow-y: overlay;
  ${({ theme }) => scrollBarStyle()}
  white-space: pre-wrap;

  /* subheadline2 */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;
  :disabled {
    background: #f9f9f9;

    color: #6e727c;
  }
`;

const ThirdDiv = styled.div`
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;
const ThirdDivTitleDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;
const ThirdDivTitleText = styled.div`
  color: var(--RG02, #25282f);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body16B */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: -0.32px;
`;
const ThirdDivTitleDescriptionText = styled.div`
  color: var(--GrayScale-gray800, #565b69);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body14M */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;
`;
const ThirdDivDateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;
const ThirdDivDateInputContainer = styled.div<{ isDisabled: boolean }>`
  display: flex;
  padding: 8px 10px;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;

  border-radius: 8px;
  border: 1px solid var(--RG06, #d8ddea);
  background: var(--RG00, #fff);

  & > input {
    width: 100%;
    background: transparent;

    ::placeholder {
      color: ${({ theme }) => theme.colors.RG04};
      font-size: 13px;
    }

    color: var(--GrayScale-black, #000);

    /* subheadline2 */
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 171.429% */
    letter-spacing: -0.28px;
  }
  ${({ isDisabled, theme }) => ({
    backgroundColor: isDisabled ? '#f9f9f9' : theme.colors.RG00,
  })}
`;
const CalanderIconContainer = styled.div<{ isActive: boolean; hasError: boolean }>`
  width: 18;
  height: 18;
  position: relative;

  :hover {
    background: ${({ theme }) => theme.colors.RC03_1};
  }

  ${({ isActive, hasError, theme }) => ({
    background: isActive ? theme.colors.RC03_1 : theme.colors.RG00,
  })}
`;
const TimeContaniner = styled.div<{ isDisabled: boolean }>`
  display: flex;
  width: 80px;
  height: 40px;
  padding: 8px 10px 8px 10px;
  align-items: center;
  gap: 10px;

  border-radius: 8px;
  border: 1px solid var(--RG06, #d8ddea);
  background: var(--RG00, #fff);
  background-color: ${({ isDisabled, theme }) => (isDisabled ? '#f9f9f9' : theme.colors.RG00)};
`;
const TimeInput = styled.input`
  background-color: inherit;
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  width: 30px;

  color: var(--GrayScale-black, #000);

  /* subheadline2 */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;

  /* padding: 8px 10px 8px 10px; */
  :disabled {
    color: #6e727c;
  }
`;
const TimeText = styled.div`
  width: 14px;
  z-index: 1;
  position: relative;

  color: var(--RG04, #8f96a9);

  /* subheadline2 */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;
`;

const FirthDiv = styled.div`
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;
const FirthDivTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;
const FirthDivTitle = styled.div`
  color: var(--RG02, #25282f);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body16B */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
  letter-spacing: -0.32px;
`;
const FirthDivDescription = styled.div`
  color: var(--GrayScale-gray800, #565b69);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body14M */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;
`;
const FirthCustomerInfoContainer = styled.div`
  display: flex;
  padding-bottom: 12px;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
  align-content: flex-start;

  overflow-y: overlay;
  ${({ theme }) => scrollBarStyle()}
`;
const FirthCustomerInfoItem = styled.div`
  display: flex;
  padding: 2px 8px 2px 10px;
  justify-content: center;
  align-items: center;
  gap: 6px;

  border-radius: 4px;
  border: 1px solid var(--RG05, #b2b8cc);
  background: var(--RG00, #fff);

  color: var(--RG03, #565b69);
  text-align: center;

  /* caption1 */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 166.667% */
  letter-spacing: -0.24px;
`;
const FirthCustomerInfoButton = styled(Button)`
  display: flex;
  height: 40px;
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  border-radius: 8px;
  border: 1px solid var(--Primary-Blue700, #2e66f6);

  ${({ theme }) => ({
    borderRadius: 8,
    border: `1px solid ${theme.colors.RG06}`,
    backgroundColor: theme.colors.RG00,
  })}

  &:hover {
    background: rgba(118, 157, 255, 0.3);
  }
`;

const ModalButtonContainer = styled.div`
  display: flex;
  padding: 20px;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  align-self: stretch;

  border-radius: 0px 0px 8px 8px;
  border-top: 1px solid var(--RG06, #d8ddea);
  background: #fff;
`;
const ModalButtonCancel = styled(Button)`
  display: flex;
  width: 216px;
  height: 40px;
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;

  ${({ theme }) => ({
    backgroundColor: theme.colors.RG00,
    color: theme.colors.RG03,
  })}

  border-radius: 8px;
  border: 1px solid var(--RG06, #d8ddea);
  background: var(--RG00, #fff);
`;
const ModalButtonAdd = styled(Button)`
  display: flex;
  width: 216px;
  height: 40px;
  padding: 8px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  border-radius: 8px;
  ${({ theme }) => ({
    backgroundColor: theme.colors.RC02,
    color: theme.colors.RG00,
  })}

  &:disabled {
    ${({ theme }) => ({
      backgroundColor: theme.colors.RG07,
      color: theme.colors.RG04,
    })}
  }
`;
const SecondDivOver90Text = styled.span`
  color: var(--Secondary-Red200, #ff4343);
  font-feature-settings: 'liga' off, 'clig' off;

  /* body14M */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.28px;
`;
const LMSLabel = styled.span`
  display: flex;
  padding: 0px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-right: 8px;

  border-radius: 4px;
  border: 1px solid var(--Secondary-Red200, #ff4343);
  background: var(--Secondary-Red200, #ff4343);

  color: var(--Secondary-Red100, #fff1f1);

  /* Caption/CaptionSB12 */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px; /* 175% */
  letter-spacing: -0.24px;
`;
